export default {
    socket: null,
    user: {
        state: 'disabled',
    },
    call: null,
    notAvailable: false,
    guest: {
        id: '',
        first_name: 'Новый гость',
        is_vip: false,
        is_blacklisted: false,
        contacts: [],
        blacklist_reason: '',
    },
    isGuestModalOpen: false,
    lastCall: null,
    endCall: false,
}
